import {createApi} from '@reduxjs/toolkit/query/react';

import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {ApiUrls} from 'shared/config/model/urls';

import ISummaryHome from '../model/ISummaryHome';

export const summaryHomeAPI = createApi({
    reducerPath: 'summaryHomeAPI',
    baseQuery: httpBaseQuery(),
    refetchOnMountOrArgChange: 60,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getSummaryHome: build.query<ISummaryHome, void>({
            query: () => ({
                path: ApiUrls.SUMMARY_HOME,
            }),
        }),
    }),
});
